export const getApiUrlFromGlobal = (
  globalConfigNestedFields: string[] | undefined
) => {
  if (!globalConfigNestedFields) return '';

  const apiUrl = globalConfigNestedFields.reduce(
    (acc, field) => acc[field],
    (globalThis as { [key: string]: any }).config
  );

  if (apiUrl[0] === ':') {
    const [protocol] = window.location.origin.split('://');

    return `${protocol}://${window.location.hostname}${apiUrl}/`;
  }

  return `${apiUrl}/`;
};
